import { Field } from 'formik';
import TextInput from '../TextInput';
import FormikControlledComboBox from '../ComboBox';
import COUNTRIES from './countriesList';
import s from './AddressInputFields.module.scss';

type AddressField = 'street' | 'zipcode' | 'town' | 'country';

interface AddressInputFieldsProps {
  /** Prefix for the input names. E.g. passing "myInput" will cause the street input
   * to be named "myInput.street" */
  namePrefix: string;
  /** Is the address required? */
  isRequired: boolean;
}

/**
 * A group of input fields for entering an address
 */
function AddressInputFields({
  isRequired,
  namePrefix,
}: AddressInputFieldsProps) {
  const fieldName = (field: AddressField) => `${namePrefix}.${field}`;

  return (
    <div className={s.input4md}>
      <Field
        name={fieldName('street')}
        labelMsg="offerWizard.StepSomeInformation.street"
        component={TextInput}
        autoComplete="address-line1"
        required={isRequired}
      />
      <div className={`${s.input4md} ${s.ZIP}`}>
        <Field
          name={fieldName('zipcode')}
          labelMsg="offerWizard.StepSomeInformation.zipcode.label"
          component={TextInput}
          autoComplete="postal-code"
          required={isRequired}
        />
        <Field
          name={fieldName('town')}
          labelMsg="offerWizard.StepSomeInformation.town.label"
          component={TextInput}
          autoComplete="address-level2"
          required={isRequired}
        />
      </div>
      <Field
        name={fieldName('country')}
        component={FormikControlledComboBox}
        options={COUNTRIES}
        labelMsg="offerWizard.StepSomeInformation.country"
        isRequired={isRequired}
      />
    </div>
  );
}

export default AddressInputFields;
